import React, { useRef } from 'react';
import './contact.css'
import { useForm } from "react-hook-form";
import emailjs from 'emailjs-com';
import 'react-toastify/dist/ReactToastify.min.css';
import { toast } from 'react-hot-toast';

const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm('service_t6gwewp', 'template_cmvwkjk', form.current, 'trfSUT23ph8L_i4Eh')
            .then((result) => {
                console.log(result.text);
                toast.success('Your message was sent')
                form.current.reset();
            }, (error) => {
                console.log(error.text);
            });
    };
    return (
        <div className='mx-5 lg:mx-40 lg:mt-20 mt-9' id='contact'>
            <h1 className='mb-5 text-3xl font-semibold text-center lg:mb-10'>Get in touch</h1>
            <form ref={form} onSubmit={sendEmail}>
                <div className='mb-4 form-control'>
                    <label className='text-start'>Name</label>
                    <input type="text" name="user_name" placeholder="name" className="w-full max-w-xs input input-bordered input-info" />
                </div>
                <div className='mb-4 form-control'>
                    <label className='text-start'>Email</label>
                    <input type="email" name="user_email" placeholder="email" className="w-full max-w-xs input input-bordered input-info" />
                </div>
                <div className='form-control'><label className='text-start'>Message</label>
                    <textarea name="message" className="h-32 textarea textarea-info w-96 lg:w-1/2 lg:h-40" rows='5' cols='10' placeholder="message" /></div>
                <input type="submit" value="Send" className='mt-4 btn contactbtn' />

            </form>
        </div>
    );
};

export default Contact;